export default __webpack_public_path__ + "static/media/anemia.93fd164a.svg";